import { get } from 'lodash';

export const parseAccount = account => ({
  id: get(account, 'id'),
});
